'use client';

import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { FlashBoldIcon } from '@depop/web-ui-kit/Icons/FlashBoldIcon';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { InfoPanel } from '@/components/InfoPanel';
import { HELP_ARTICLES } from '@/constants/helpUrls.ts';
import { useEducationViewTracker } from '@/modules/userEducation/useEducationViewTracker';

type Props = {
  isEnabled: boolean;
  incrementCountTrigger: unknown;
};

export function BoostedListingsInfoPanel({
  isEnabled,
  incrementCountTrigger,
}: Props) {
  const t = useTranslations('search');

  const { shouldDisplayComponent, dismiss } = useEducationViewTracker({
    isEnabled,
    educationComponentKey: 'search_navigation_introducing_boosted_listings',
    incrementTrigger: incrementCountTrigger,
  });

  if (!shouldDisplayComponent) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <InfoPanel
        IconComponent={FlashBoldIcon}
        title={t('BoostedListings.EducationBanner.Title')}
        onClose={dismiss}
      >
        <Caption variant="lg-regular">
          {t('BoostedListings.EducationBanner.Description')}{' '}
          <a
            className={styles.link}
            href={HELP_ARTICLES.BOOSTED_LISTINGS.TERMS_AND_CONDITIONS}
            onClick={() => dismiss()}
          >
            {t('BoostedListings.EducationBanner.DescriptionLink')}
          </a>
        </Caption>
      </InfoPanel>
    </div>
  );
}
